import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

import dashboardImage from "../assets/image4.jpeg";
import invoiceImage from "../assets/image2.jpeg";

import {
  ArrowRight,
  CheckCircle2,
  FileText,
  IndianRupee,
  Package,
  Users,
  Zap,
  BarChart3,
  ShieldCheck,
  Clock3,
  Smartphone,
  Settings2,
} from "lucide-react";

import "../public css/Homep.css";

const Home = () => {
  const whySectionRef = useRef(null);

useEffect(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("why-visible");
        observer.unobserve(entry.target);
      }
    },
    {
      threshold: 0.15,
    }
  );

  if (whySectionRef.current) {
    observer.observe(whySectionRef.current);
  }

  return () => observer.disconnect();
}, []);
  return (
    <div className="billing-home">

    

      <section className="billing-hero">

        {/* Background Effects */}
        <div className="hero-glow hero-glow-one"></div>
        <div className="hero-glow hero-glow-two"></div>

        <div className="hero-grid"></div>

        <div className="hero-container">

          {/* LEFT CONTENT */}

          <div className="hero-content">

            <div className="hero-badge">
              <span className="badge-pulse"></span>
              Smart Billing Platform
            </div>

            <h1>
              Billing that makes
              <span> business simpler.</span>
            </h1>

            <p>
              Create invoices, manage inventory, track customers
              and monitor your business from one powerful
              billing platform.
            </p>

            <div className="hero-actions">

              <Link
                to="/about"
                className="hero-primary-btn"
              >
                 Explore More
                <ArrowRight size={18} />
              </Link>

              {/* <Link
                to="/about"
                className="hero-secondary-btn"
              >
                Explore MORE
              </Link> */}

            </div>

            <div className="hero-trust">

              <div className="trust-item">
                <CheckCircle2 size={16} />
                Easy to use
              </div>

              <div className="trust-item">
                <CheckCircle2 size={16} />
                Fast invoicing
              </div>

              <div className="trust-item">
                <CheckCircle2 size={16} />
                Business ready
              </div>

            </div>

          </div>


     
       <div className="billing-visual">

            <div className="visual-orbit orbit-one"></div>
            <div className="visual-orbit orbit-two"></div>

            {/* Main Invoice */}

            {/* <div className="invoice-card">

              <div className="invoice-header">

                <div>
                  <span className="invoice-small">
                    INVOICE
                  </span>

                  <strong>
                    #INV-2026-001
                  </strong>
                </div>

                <div className="invoice-logo">
                  D
                </div>

              </div>

              <div className="invoice-line"></div>

              <div className="invoice-customer">
                <div>
                  <small>BILLED TO</small>
                  <strong>Rahul Sharma</strong>
                </div>

                <div className="invoice-paid">
                  PAID
                </div>
              </div>

              <div className="invoice-items">

                <div className="invoice-item">
                  <span>Premium Product</span>
                  <strong>₹12,500</strong>
                </div>

                <div className="invoice-item">
                  <span>Service Charges</span>
                  <strong>₹2,500</strong>
                </div>

                <div className="invoice-item">
                  <span>GST 18%</span>
                  <strong>₹2,700</strong>
                </div>

              </div>

              <div className="invoice-total">
                <span>Total Amount</span>
                <strong>₹17,700</strong>
              </div>

            </div> */}
<div className="invoice-card">
  <img
    src={invoiceImage}
    alt="Dectwin Billing Invoice"
    className="invoice-image"
  />
</div>

      

            <div className="floating-card sales-card">

              <div className="floating-icon sales-icon">
                <IndianRupee size={18} />
              </div>

              <div>
                <small>Total Sales</small>
                <strong>₹1,25,500</strong>

                <span className="growth">
                  ↗ 12.5%
                </span>
              </div>

            </div>


            {/* Floating Customer Card */}

            <div className="floating-card customer-card">

              <div className="floating-icon customer-icon">
                <Users size={18} />
              </div>

              <div>
                <small>Customers</small>
                <strong>342+</strong>
              </div>

            </div>


            {/* Floating Invoice Card */}

            <div className="floating-mini invoice-mini">

              <FileText size={18} />

              <div>
                <strong>156</strong>
                <small>Invoices</small>
              </div>

            </div>

          </div>

        </div>

      </section>


      {/* ================= FEATURES ================= */}

      <section className="billing-features">

        <div className="features-heading">

          <span>
            EVERYTHING YOU NEED
          </span>

          <h2>
            One platform.
            <br />
            Complete billing control.
          </h2>

          <p>
            Everything you need to manage your daily
            business operations efficiently.
          </p>

        </div>


        <div className="features-grid">

          <div className="billing-feature-card">

            <div className="feature-icon orange">
              <FileText size={22} />
            </div>

            <h3>
              Smart Invoicing
            </h3>

            <p>
              Create professional invoices in seconds
              and keep your billing organized.
            </p>

            <Link to="/about">
              Learn more <ArrowRight size={14} />
            </Link>

          </div>


          <div className="billing-feature-card">

            <div className="feature-icon blue">
              <Package size={22} />
            </div>

            <h3>
              Inventory Management
            </h3>

            <p>
              Track products, stock and inventory
              without complicated spreadsheets.
            </p>

            <Link to="/about">
              Learn more <ArrowRight size={14} />
            </Link>

          </div>


          <div className="billing-feature-card">

            <div className="feature-icon purple">
              <Users size={22} />
            </div>

            <h3>
              Customer Management
            </h3>

            <p>
              Keep customer information and billing
              history organized in one place.
            </p>

            <Link to="/about">
              Learn more <ArrowRight size={14} />
            </Link>

          </div>


          <div className="billing-feature-card">

            <div className="feature-icon green">
              <Zap size={22} />
            </div>

            <h3>
              Fast & Powerful
            </h3>

            <p>
              Designed for speed so you can spend
              less time managing billing.
            </p>

            <Link to="/about">
              Learn more <ArrowRight size={14} />
            </Link>

          </div>

        </div>

      </section>
      <section
        ref={whySectionRef}
       className="why-dectwin">

        <div className="why-container">

          {/* LEFT */}

          <div className="why-content">

            <span className="section-label">
              WHY DECTWIN
            </span>

            <h2>
              Everything your business
              needs to grow.
            </h2>

            <p>
              Dectwinn brings billing, inventory, customers
              and business insights together in one simple
              platform designed for modern businesses.
            </p>


            <div className="why-list">

              <div className="why-item">

                <div className="why-icon">
                  <ShieldCheck size={20} />
                </div>

                <div>
                  <h4>
                    Secure & Reliable
                  </h4>

                  <p>
                    Your business data stays protected
                    and organized.
                  </p>
                </div>

              </div>


              <div className="why-item">

                <div className="why-icon">
                  <Clock3 size={20} />
                </div>

                <div>
                  <h4>
                    Save Valuable Time
                  </h4>

                  <p>
                    Automate repetitive billing and
                    inventory tasks.
                  </p>
                </div>

              </div>


              <div className="why-item">

                <div className="why-icon">
                  <Smartphone size={20} />
                </div>

                <div>
                  <h4>
                    Works Everywhere
                  </h4>

                  <p>
                    Access your business from desktop,
                    tablet or mobile.
                  </p>
                </div>

              </div>

            </div>

          </div>


          {/* RIGHT VISUAL */}

          {/* <div className="why-dashboard">

            <div className="dashboard-top">

              <div>
                <span>Business Overview</span>
                <strong>March 2026</strong>
              </div>

              <BarChart3 size={24} />

            </div>


            <div className="dashboard-sales">

              <span>Total Revenue</span>

              <strong>
                ₹8,45,600
              </strong>

              <small>
                ↗ 18.4% from last month
              </small>

            </div>


            <div className="dashboard-bars">

              <div className="bar-item">
                <span>Mon</span>
                <div className="bar">
                  <i style={{ height: "45%" }}></i>
                </div>
              </div>

              <div className="bar-item">
                <span>Tue</span>
                <div className="bar">
                  <i style={{ height: "65%" }}></i>
                </div>
              </div>

              <div className="bar-item">
                <span>Wed</span>
                <div className="bar">
                  <i style={{ height: "52%" }}></i>
                </div>
              </div>

              <div className="bar-item">
                <span>Thu</span>
                <div className="bar">
                  <i style={{ height: "80%" }}></i>
                </div>
              </div>

              <div className="bar-item">
                <span>Fri</span>
                <div className="bar">
                  <i style={{ height: "70%" }}></i>
                </div>
              </div>

              <div className="bar-item">
                <span>Sat</span>
                <div className="bar">
                  <i style={{ height: "92%" }}></i>
                </div>
              </div>

              <div className="bar-item">
                <span>Sun</span>
                <div className="bar">
                  <i style={{ height: "76%" }}></i>
                </div>
              </div>

            </div>


            <div className="dashboard-bottom">

              <div>
                <span>Invoices</span>
                <strong>1,248</strong>
              </div>

              <div>
                <span>Customers</span>
                <strong>342</strong>
              </div>

              <div>
                <span>Products</span>
                <strong>856</strong>
              </div>

            </div>

          </div> */}
          {/* RIGHT VISUAL */}

<div className="why-dashboard">

  <div className="dashboard-image-wrapper">
    <img
      src={dashboardImage}
      alt="Dectwin Billing Dashboard"
      className="dashboard-image"
    />
  </div>

</div>

        </div>

      </section>

<section className="how-it-works">

        <div className="how-heading">

          <span className="section-label">
            HOW IT WORKS
          </span>

          <h2>
            Start managing your business
            in three simple steps.
          </h2>

          <p>
            Dectwinn keeps your daily business operations
            simple, organized and efficient.
          </p>

        </div>


        <div className="steps-grid">

          {/* STEP 1 */}

          <div className="step-card">

            <div className="step-number">
              01
            </div>

            <div className="step-icon">
              <Settings2 size={24} />
            </div>

            <h3>
              Set Up Your Business
            </h3>

            <p>
              Add your business details, products,
              customers and billing preferences.
            </p>

          </div>


          {/* STEP 2 */}

          <div className="step-card">

            <div className="step-number">
              02
            </div>

            <div className="step-icon">
              <FileText size={24} />
            </div>

            <h3>
              Create Invoices
            </h3>

            <p>
              Generate professional invoices quickly
              and keep every transaction organized.
            </p>

          </div>


          {/* STEP 3 */}

          <div className="step-card">

            <div className="step-number">
              03
            </div>

            <div className="step-icon">
              <BarChart3 size={24} />
            </div>

            <h3>
              Track & Grow
            </h3>

            <p>
              Monitor sales, inventory and customers
              to make smarter business decisions.
            </p>

          </div>

        </div>

      </section>
<section className="billing-trust">

        <div className="trust-container">

          <div className="trust-heading">

            <span className="section-label">
              BUILT FOR BUSINESS
            </span>

            <h2>
              Simple tools.
              <br />
              Powerful results.
            </h2>

          </div>


          <div className="trust-points">

            <div className="trust-point">
              <CheckCircle2 size={19} />
              <span>
                Professional invoices
              </span>
            </div>

            <div className="trust-point">
              <CheckCircle2 size={19} />
              <span>
                Real-time business insights
              </span>
            </div>

            <div className="trust-point">
              <CheckCircle2 size={19} />
              <span>
                Easy inventory tracking
              </span>
            </div>

            <div className="trust-point">
              <CheckCircle2 size={19} />
              <span>
                Organized customer records
              </span>
            </div>

          </div>

        </div>

      </section>

    </div>
  );
};

export default Home;